import { useReportLegacyShellLeak } from '@upright/ui/views/unified-shell/use-report-legacy-shell-leak';
import { DesktopOnly, TabletOrNarrowerOnly } from '../../layout/breakpoint-utils';
import { DesktopHeader } from './desktop-header';
import { MobileHeader } from './mobile-header';

export function BouToolHeader() {
  // A tripwire for future render sites: today the only one, `header-maybe.tsx`, renders this header
  // only when the user is not in the unified shell, so the report cannot fire from there.
  useReportLegacyShellLeak('BouToolHeader');
  return (
    <div>
      <DesktopOnly>
        <DesktopHeader />
      </DesktopOnly>
      <TabletOrNarrowerOnly>
        <MobileHeader />
      </TabletOrNarrowerOnly>
    </div>
  );
}
